import { useIsDarkTheme } from './useIsDarkTheme';
import videoDarkThumbnail from '../assets/images/video-dark-thumbnail.png';
import videoLightThumbnail from '../assets/images/video-light-thumbnail.png';

export const useVideoThumbnail = () => {
  // An instance's forced theme, else the student's own; light signed out.
  const isDarkTheme = useIsDarkTheme();

  return isDarkTheme ? videoDarkThumbnail : videoLightThumbnail;
};
